import { PageHeader } from 'components/page-header/page-header'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslate, useWindowDimensions } from 'utils'
import { useConfig, useResources } from 'api'
import { useNavigate } from 'react-router-dom'
import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'
import { useState } from 'react'
import { PageContentWrapper, VerticalContainer } from 'components/styled'
import { theme } from 'antd'
import { FormSection } from 'components/form-section/form-section'
import { ResourceItem } from 'components/resource/resource-item/resource-item'
import { ResourceTypeSelect } from 'components/resource/resource-type-select/resource-type-select'

export const ResourcesList = () => {

    //hooks:
    const { token: { paddingMD, marginXXS, margin, padding } } = theme.useToken()
    const { SM } = useWindowDimensions()
    const { __ } = useTranslate()
    const { data: config } = useConfig()
    const navigate = useNavigate()

    //state:
    const [ typeId, setTypeId ] = useState<string>('all')
    const [ searchResources, setSearchResources ] = useState<string | null>(null)
    
    //api:
    const {
        data: resources,
        pageNum,
        totalPages,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useResources(null, typeId === 'all' ? null : typeId, null, [], searchResources)
    const { data: allResources, total: allTotal } = useResources(null, null, null, [], null)

    const allTypesOption = { value: 'all', label: __`all_types` }

    return !config ? null : (
        
        <PageContentWrapper>

            <VerticalContainer style={{ gap: SM ? margin : marginXXS }}>

                {/* header */}
                <PageHeader
                    title={__`resources`}
                    description={__`manage_resources_things_like_team_members_rooms_and_machines`}
                    primaryButton={{
                        name: SM ? __`create_resource` : __`create`,
                        icon: <PlusOutlined/>,
                        mode: (allResources && (allTotal ?? 0) < (config.plan?.maxResources ?? 0)) ? 'normal' : 'disabled',
                        title: (allResources && (allTotal ?? 0) < (config.plan?.maxResources ?? 0)) ? undefined : __`you_reached_your_plans_max_limit`,
                        onClick: () => navigate('/resource/new')
                    }}
                />

                <div style={{ padding: SM ? `0 ${padding}px` : 0 }}>
                
                    <FormSection
                        title={SM ? __`resources` : undefined }
                        childrenWrapperStyle={{ padding: SM ? `0 ${paddingMD}px` : 0 }}
                        topNode={
                            <ResourceTypeSelect
                                extraOptions={[allTypesOption]}
                                value={typeId}
                                onResourceTypeSelect={type => setTypeId(type.id)}
                                style={{ minWidth: SM ? 190 : 150, maxWidth: SM ? 190 : 150 }}
                            ></ResourceTypeSelect>
                        }
                        searchInput={{
                            placeholder: __`search_resources`,
                            onSearch: setSearchResources
                        }}
                    >

                        {/* list */}
                        <VerticalPaginatedList
                            isFirstLoading={isLoading}
                            isForbidden={resources === null}
                            isError={resources === false}
                            notFound={(resources && resources.length === 0) ?? false}
                            totalPages={totalPages}
                            pageNum={pageNum}
                            isPreviousData={isPreviousData}
                            isNextDisabled={isNextDisabled}
                            isPreviousDisabled={isPreviousDisabled}
                            fetchNext={fetchNext}
                            fetchPrevious={fetchPrevious}
                        >
                            {resources && resources?.map(resource => (
                                <ResourceItem
                                    key={resource.id}
                                    resource={resource}
                                />
                            ))}
                        </VerticalPaginatedList>

                    </FormSection>

                </div>

            </VerticalContainer>

        </PageContentWrapper>
    )
    
}
